import xhr from '../xhr/'
import utilService from './utilService'
import store from 'store'

var wx = require('weixin-js-sdk');

class WechatService {

	cookie (name) {
		var arrstr = document.cookie.split("; ");
		for(var i = 0;i < arrstr.length;i ++){
			var temp = arrstr[i].split("=");
			if(temp[0] == name) return decodeURI(temp[1]);
		}
		return "";
	}

	auth (iid, callback, needUserInfo) {
		if (!wx)  return;
		let openid = this.cookie('openid_'+iid)
		// let unionId = this.cookie('unionid_'+iid)
		//scope为snsapi_userinfo才能拉到头像
		xhr({ url: '/user/getUserInfo', body: {openId:openid, iid} })
			.then(result => {
				var userInfo = result;
				if (((!userInfo.openid||!userInfo.unionid) && !!userInfo.appId)
					|| (needUserInfo && !userInfo.nickname) ){
					// openid 对应的用户信息已无，需要重新获取，用snsapi_base静默获取
					// 如果需要取用户头像，才用snsapi_userinfo让用户同意授权
					var scope = needUserInfo?'snsapi_userinfo':'snsapi_base'
					var return_url = encodeURIComponent(location.href)
					var urlHead = 'https'
					// if(window.location.hostname.indexOf(userInfo.domain) != -1) {//是否支持https
					// 	urlHead = 'https'
					// 	if ( navigator.userAgent.indexOf('wechatdevtools') !== -1 ) {
					// 		urlHead = 'http'
					// 	}
					// }
					var redirect_uri = encodeURIComponent(urlHead+'://'+window.location.hostname+'/api/user/code?return_url='+return_url);
					var state = encodeURIComponent('iid='+iid)
					var wxurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + userInfo.appId+
															"&redirect_uri="+ redirect_uri+
															"&response_type=code&scope="+ scope +
															"&state="+state+"#wechat_redirect";
					window.location.href = wxurl;
					return;
				}
				store.set("global_unionid", userInfo.unionid)//作为后台接口统计
				callback({
					openid: userInfo.openid,
					unionid:userInfo.unionid,
					nickname:userInfo.nickname,
					headimgurl:userInfo.headimgurl
				});
			}, error => {
				callback(null)
			});
	}

	jsapi (iid, shareConfig=null, jsApiList=[], timelineTitle) {
		if (!wx)  return;
		// if (wx && wx.isReady) return;
		xhr({ url: '/user/ticket', body: { iid } })
			.then(result => {
				var ticket = result;
				var wechatConfig = {
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: ticket.appId, // 必填，公众号的唯一标识
					timestamp: ticket.timestamp, // 必填，生成签名的时间戳
					nonceStr: ticket.nonceStr, // 必填，生成签名的随机串
					signature: ticket.signature,// 必填，签名，见附录1
					jsApiList: jsApiList//['onMenuShareTimeline', 'onMenuShareAppMessage','chooseWXPay']
				};
				wx.config(wechatConfig);
	            wx.ready(function () {
	                console.log('wxJsAPI is ready!');
					// console.log(shareConfig)
					wx.isReady = true;
					if (!!shareConfig) {
						//初始化分享
						// console.log(jsApiList)
						// "menu:share:timeline", "menu:share:appmessage"
						if (jsApiList.indexOf('menu:share:timeline') != -1) {
							// 分享到朋友圈
							wx.onMenuShareTimeline({
							    title: timelineTitle?timelineTitle:shareConfig.title, // 分享标题
							    link: shareConfig.link, // 分享链接
							    imgUrl: shareConfig.imgUrl, // 分享图标
									success: function () {
			            	// window.alert("分享成功");
										utilService.recordData({iid:iid, rid:'', type:1, p:shareConfig.link})
										if(typeof shareConfig.success === 'function') {
											shareConfig.success(1);
										}
											
			            }
							})
						}
						if (jsApiList.indexOf('menu:share:appmessage') != -1) {
							// 分享到微信朋友
							wx.onMenuShareAppMessage({
							    title: shareConfig.title, // 分享标题
							    desc: shareConfig.desc, // 分享描述
							    link: shareConfig.link, // 分享链接
							    imgUrl: shareConfig.imgUrl, // 分享图标
									success: function () {
			            	// window.alert("朋友圈分享成功");
										utilService.recordData({iid:iid, rid:'', type:2, p:shareConfig.link})
										if(typeof shareConfig.success === 'function') {
											shareConfig.success(2);
										}
			            }
							})
						}
					}
	            });
        	});
	}

	pay ({data, cb} = {}) {
		
		if (!wx)  return;
		// if (wx && !wx.isReady) return;
		console.log('data',data)
		wx.chooseWXPay({
			timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
			nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
			package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
			signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
			paySign: data.paySign, // 支付签名
			success: function (res) {
				if(res.errMsg){
					if(res.errMsg == "chooseWXPay:ok"){
						cb("success");
					}else{
						cb("error");
					}
				}
			},
			cancel:function(){
				cb("cancel");
			},
			fail:function(res){
				cb(res.errMsg);//res:{"errMsg":"chooseWXPay:fail"}
			}
		});
	}

	imagePreview(curSrc,srcList) {
		if (!wx)  return;
		/**
		 * 调起微信Native的图片播放组件。
		 * 这里必须对参数进行强检测，如果参数不合法，直接会导致微信客户端crash
		 *
		 * @param {String} curSrc 当前播放的图片地址
		 * @param {Array} srcList 图片地址列表
		 */
		wx.previewImage({
			current: curSrc,
			urls: srcList
		});
	}
}

// 实例化后再导出
export default new WechatService()
